<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  /** Size of the spinner in pixels */
  size?: number
}

const { size = 30 } = defineProps<Props>()

defineOptions({
  name: 'LoadingSpinner'
})

const style = computed(() => {
  return `
    border: ${size * 0.15}px solid rgba(0, 0, 0, 0.1);
    height: ${size}px; width: ${size}px;
    border-radius: 50%;`
})
</script>

<template>
  <div
    role="alert"
    aria-busy="true"
    class="donut-spinner text-primary"
    :style
  />
</template>

<style lang="scss" scoped>
@reference '../../styles/main.css';

.donut-spinner {
  display: inline-block;
  border-left-color: var(--color-primary) !important;
  animation: donut-spin 1.5s linear infinite;
}
</style>
